import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'

const swiperOptions = {
  init: false,
  keyboard: true,
  speed: 400,
  spaceBetween: 0,
  slidesPerView: 1,
  centeredSlides: false,
  effect: 'fade',
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true
  },
  loop: true,
  autoplay: {
    delay: 5000
  },
  allowTouchMove: false
}

export default {
  components: {
    Swiper
  },
  data: () => ({
    swiperRef: undefined,
    swiperActiveIndex: 0
  }),
  directives: {
    'swiper-heroes': {
      inserted (el, binding, vnode) {
        const swiperRef = new Swiper(el, swiperOptions)
        vnode.context.$data.swiperRef = swiperRef
        swiperRef.on('slideChange', function () {
          vnode.context.$data.swiperActiveIndex = vnode.context.$data.swiperRef.activeIndex
        });
        vnode.context.$data.swiperRef.init()
        vnode.context.$data.swiperRef.update()
        // change behaviour of transition on bullets
        const bullets = el.querySelectorAll('.swiper-pagination-bullet')
        bullets.forEach((bullet) => {
          bullet.addEventListener('click', () => {
            el.querySelector('.swiper-pagination-bullets').classList.add('swiper-pagination-bullets--already-clicked')
          })
        })
      },
      componentUpdated (el, binding, vnode) {
        // console.log('siamo in ' + vnode.context.$data.swiperActiveIndex)
      },
      unbind (el, binding, vnode) {
        vnode.context.$data.swiperRef.destroy()
      }
    }
  }
}
